/**
 * Shared constants + formatters for the AR Collections module.
 * Extracted in Iter 82 to keep FinanceCollections.jsx focused on layout only.
 */
import { Mail, MessageCircle, MessageSquare } from "lucide-react";

export const fmt = (n) => {
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency", currency: "INR", maximumFractionDigits: 2,
    }).format(Number(n || 0));
  } catch {
    return `₹${Number(n || 0).toFixed(2)}`;
  }
};

export const STATUS_META = {
  new: { label: "New", tone: "bg-muted text-muted-foreground" },
  in_followup: { label: "In follow-up", tone: "bg-blue-500/15 text-blue-700 dark:text-blue-300" },
  promised: { label: "Payment promised", tone: "bg-amber-500/15 text-amber-700 dark:text-amber-300" },
  broken_promise: { label: "Broken promise", tone: "bg-rose-500/15 text-rose-700 dark:text-rose-300" },
  disputed: { label: "Disputed", tone: "bg-purple-500/15 text-purple-700 dark:text-purple-300" },
  resolved: { label: "Resolved", tone: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300" },
  written_off: { label: "Written off", tone: "bg-slate-500/15 text-slate-700 dark:text-slate-300" },
};

export const BUCKET_TONE = {
  current: "text-emerald-600",
  "1-30": "text-yellow-600",
  "31-60": "text-orange-600",
  "61-90": "text-rose-500",
  "90+": "text-rose-700 font-semibold",
};

export const CHANNEL_ICON = { email: Mail, whatsapp: MessageCircle, sms: MessageSquare };
